import { markApplicationAsStandalone, StandaloneAppConfig } from '@questrade/mfe-tools';
import { environment } from './environments';

markApplicationAsStandalone(<StandaloneAppConfig>environment);

import('./bootstrap');
